import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CalendarEvent } from '@shared/calendar';

@Injectable({
	providedIn: 'root',
})
export class LeftBarService {
	constructor(private http: HttpClient) {}

	// Observable string sources
	private missionAnnouncedSource = new Subject<string>();

	// Observable string streams
	missionAnnounced$ = this.missionAnnouncedSource.asObservable();

	// Observable string sources
	private taskListAnnouncedSource = new Subject<string>();

	// Observable string streams
	taskListAnnounced$ = this.taskListAnnouncedSource.asObservable();

	private eventAnnouncedSource = new Subject<CalendarEvent>();
	eventAnnounced$ = this.eventAnnouncedSource.asObservable();

	private reloadLeftMenuAnnouncedSource = new Subject<object>();
	reloadLeftMenuAnnounced$ = this.reloadLeftMenuAnnouncedSource.asObservable();

	// Service message commands
	announceMission(mission: string) {
		this.missionAnnouncedSource.next(mission);
	}

	leftMenuReload(mission: any) {
		this.reloadLeftMenuAnnouncedSource.next(mission);
	}

	// Service message commands
	announceTaskList(mission: any) {
		this.taskListAnnouncedSource.next(mission);
	}

	announceEvent(event) {
		this.eventAnnouncedSource.next(event);
	}

	// Get task list
	getTaskList(number, month) {
		return this.http.get('/api/JobTasks/getJobTaskByUserId?number=' + number + '&month=' + month);
	}
}
